module.exports = __webpack_public_path__ + "media/images/entities_logo/logo_iac-df18af677117f13fd839118569424d86.png";